export const DOCUMENT_STATE__INITIAL = 'Initial';
export const DOCUMENT_STATE__PENDING = 'Pending';
export const DOCUMENT_STATE__READY = 'Ready';
export const DOCUMENT_STATE__ERROR = 'Error';
export const DOCUMENT_STATES = [
  DOCUMENT_STATE__INITIAL,
  DOCUMENT_STATE__PENDING,
  DOCUMENT_STATE__READY,
  DOCUMENT_STATE__ERROR,
];
